// extracted by mini-css-extract-plugin
module.exports = {"alk_privacy_content":"CSOPrivacy_alk_privacy_content__1kWft","item":"CSOPrivacy_item__3MjbK"};